import { useEffect, useState } from "react";
import LogoContainer from "./LogoContainer";
import { enqueueSnackbar } from "notistack";
import {
  Box,
  Button,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  confirm_password,
  login,
  otp_verification,
  two_Step_verification,
} from "../../../DAL/auth/auth";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import PhoneInput from "react-phone-number-validation";
import { isValidPhoneNumber } from "libphonenumber-js";
import DashboardHeader from "../../headers/DashboardHeader";

export default function TwoStepWithCalidation() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedMethod, setSelectedMethod] = useState("email");
  const [fromState, setFormState] = useState(0);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordVisibleConfirm, setPasswordVisibleConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordRules, setShowPasswordRules] = useState(true);
  const [timer, setTimer] = useState(120);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneData, setPhoneData] = useState({});

  const handleChangePhone = (value, country) => {
    const cleaned = value;
    setPhoneData(country);
    setPhoneNumber(value);
    setInputs((prev) => ({
      ...prev,
      phone_number: cleaned,
    }));
  };

  const [inputs, setInputs] = useState({
    email: "",
    phone_number: "",
    password: "",
    confirm_password: "",
  });

  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    uppercase: false,
    number: false,
    specialChar: false,
  });

  const [loginStates, setLoginStates] = useState({
    verification_code: "",
  });

  const [errors, setErrors] = useState({ verification_code: "" });

  const getPasswordValidation = (password) => {
    return {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      number: /\d/.test(password),
      specialChar:
        /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\[\]\:\;\"\'\<\>\,\.\/\\\|\`\~\?]/.test(
          password
        ),
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));

    if (name === "password") {
      setPasswordValidation(getPasswordValidation(value));
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  const handleSubmit = async (e, check_value) => {
    e.preventDefault();

    const isValidNumberCheck = isValidPhoneNumber(
      inputs?.phone_number,
      phoneData?.iso2?.toUpperCase()
    );

    if (!isValidNumberCheck && selectedMethod === "phone_number") {
      enqueueSnackbar("Please enter a valid phone number", {
        variant: "error",
      });
      return;
    }

    let selectedValue =
      selectedMethod === "email" ? inputs?.email : inputs?.phone_number;

    const data = {
      source_type: selectedMethod,
      source: selectedValue,
      login_by: "forget_password",
    };

    if (selectedMethod === "phone_number") {
      data.email = inputs?.email;
    }

    if (!check_value) {
      setIsLoading(true);
    } else {
      setIsResendDisabled(true);
      setTimer(120);
      localStorage.removeItem("type");
    }
    const response = await two_Step_verification(data);
    if (response.code === 200) {
      if (!check_value) {
        enqueueSnackbar(response.message, { variant: "success" });
        setIsResendDisabled(true);
        setIsLoading(false);
        setFormState(1);
      } else {
        enqueueSnackbar("OTP resent successfully!", { variant: "success" });
      }
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleSubmitConfirm = async (e) => {
    e.preventDefault();
    const passwordRegex =
      /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\[\]\:\;\"\'\<\>\,\.\/\\\|\`\~\?]/.test(
        inputs.password
      );

    if (!passwordRegex) {
      enqueueSnackbar("Password does not meet requirements.", {
        variant: "error",
      });
      setIsLoading(false);
      return;
    }

    if (inputs.password !== inputs.confirm_password) {
      enqueueSnackbar(
        "Oops! Your passwords don’t match. Please make sure both fields are the same.",
        {
          variant: "error",
        }
      );
      setIsLoading(false);
      return;
    }

    let selectedValue =
      selectedMethod === "email" ? inputs?.email : inputs?.phone_number;
    const data = {
      source_type: selectedMethod,
      source: selectedValue,
      password: inputs.password,
      confirm_password: inputs.confirm_password,
    };
    setIsLoading(true);
    const response = await confirm_password(data);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setIsLoading(false);
      navigate("/login");
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChangeOtp = (e) => {
    const { name, value } = e.target;

    if (value.length > 6) {
      setErrors((prev) => ({
        ...prev,
        verification_code: "You can only type a 6-digit OTP",
      }));
      return;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    setLoginStates({ ...loginStates, [e.target.name]: e.target.value });
  };

  const handleSubmitOtp = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    let selectedValue =
      selectedMethod === "email" ? inputs?.email : inputs?.phone_number;

    const data = {
      source_type: selectedMethod,
      source: selectedValue,
      verification_code: loginStates.verification_code,
    };

    const response = await otp_verification(data);

    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setIsLoading(false);
      setFormState(2);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let interval = null;

    if (isResendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setIsResendDisabled(false);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timer, isResendDisabled]);

  useEffect(() => {
    let type_set = localStorage.getItem("type");
    if (type_set) {
      setSelectedMethod(type_set);
    }
  }, []);

  return (
    <div className="header-container">
      <DashboardHeader />
      <div className={`${isMobile ? "" : "pageContainer"}`}>
        <LogoContainer />
        <div className={`${isMobile ? "new-form" : "form-layout"}`}>
          <div style={styles.scrollableFormWrapper}>
            <div style={styles.formContainer}>
              <div style={styles.formContent}>
                <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                  <h2 style={{ marginBottom: "16px" }}>
                    {fromState === 0
                      ? "Two-Step Verification Method"
                      : fromState === 1
                      ? "Verification Code"
                      : "Reset Password"}
                  </h2>
                  {fromState === 0 && (
                    <p style={{ marginBottom: "24px" }}>
                      What is your preferred method to receive your verification
                      code?
                    </p>
                  )}
                  {fromState === 0 ? (
                    <form onSubmit={handleSubmit}>
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "16px",
                          marginBottom: "12px",
                          backgroundColor:
                            selectedMethod === "phone_number"
                              ? "#f0f7ff"
                              : "white",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedMethod("phone_number")}
                      >
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <input
                            type="radio"
                            name="verificationMethod"
                            value="sms"
                            checked={selectedMethod === "phone_number"}
                            onChange={() => {}}
                            style={{ marginRight: "12px", marginTop: "3px" }}
                          />
                          <div>
                            <div
                              style={{
                                fontWeight: "bold",
                                marginBottom: "4px",
                              }}
                            >
                              SMS Text Message
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "16px",
                          backgroundColor:
                            selectedMethod === "email" ? "#f0f7ff" : "white",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedMethod("email")}
                      >
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <input
                            type="radio"
                            name="verificationMethod"
                            value="email"
                            checked={selectedMethod === "email"}
                            style={{ marginRight: "12px", marginTop: "3px" }}
                          />
                          <div>
                            <div
                              style={{
                                fontWeight: "bold",
                                marginBottom: "4px",
                              }}
                            >
                              Email
                            </div>
                          </div>
                        </div>
                      </div>
                      {selectedMethod === "email" ? (
                        <TextField
                          fullWidth
                          required
                          label="Email"
                          name="email"
                          type="email"
                          value={inputs.email}
                          onChange={handleChange}
                          margin="normal"
                        />
                      ) : (
                        <div className="mt-3 position-relative">
                          <div className="small_title">Phone Number *</div>
                          <PhoneInput
                            placeholder=" "
                            value={phoneNumber}
                            setValue={setPhoneNumber}
                            onChange={handleChangePhone}
                            inputClass="phone_input"
                            autoSelectCountry={true}
                            enableSearch={true}
                            countryCodeEditable={false}
                            required={true}
                          />
                        </div>
                      )}

                      <Button
                        type="submit"
                        variant="contained"
                        className="mt-3"
                        fullWidth
                        disabled={isLoading}
                      >
                        {isLoading ? "Sending..." : "Send"}
                      </Button>
                    </form>
                  ) : fromState === 1 ? (
                    <form onSubmit={handleSubmitOtp} className="mt-3">
                      {selectedMethod === "email" && (
                        <Box mb={2}>
                          <TextField
                            label="Email"
                            placeholder="Your registered email"
                            fullWidth
                            required
                            type="email"
                            disabled
                            name="email"
                            value={inputs.email}
                            InputLabelProps={{
                              shrink: Boolean(inputs.email),
                            }}
                          />
                        </Box>
                      )}

                      {selectedMethod === "phone_number" && (
                        <Box mb={2} mt={4}>
                          <TextField
                            label="Mobile Number"
                            placeholder="Your mobile number"
                            fullWidth
                            required
                            type="tel"
                            disabled
                            name="phoneNumber"
                            value={inputs?.phone_number}
                            InputLabelProps={{
                              shrink: Boolean(inputs?.phone_number),
                            }}
                          />
                        </Box>
                      )}

                      <Box mb={2}>
                        <TextField
                          label="Verification Code"
                          fullWidth
                          required
                          name="verification_code"
                          type="number"
                          value={loginStates.verification_code}
                          onChange={handleChangeOtp}
                          error={!!errors.verification_code}
                          helperText={errors.verification_code}
                        />
                      </Box>

                      <Box mb={2} textAlign="end">
                        {isResendDisabled ? (
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "14px", color: "#555" }}
                          >
                            You can resend the code in{" "}
                            <strong>
                              {Math.floor(timer / 60)}:
                              {String(timer % 60).padStart(2, "0")}
                            </strong>
                          </Typography>
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "14px", color: "#555" }}
                          >
                            Didn’t receive the code?{" "}
                            <span
                              style={{
                                color: "#1976d2",
                                cursor: "pointer",
                                fontWeight: 500,
                              }}
                              type="button"
                              onClick={(e) => {
                                handleSubmit(e, true);
                              }}
                            >
                              Resend OTP
                            </span>
                          </Typography>
                        )}
                      </Box>

                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={isLoading}
                      >
                        {isLoading ? "Verifying..." : "Verify OTP"}
                      </Button>
                    </form>
                  ) : (
                    <form onSubmit={handleSubmitConfirm}>
                      <TextField
                        fullWidth
                        required
                        label="Password"
                        name="password"
                        type={passwordVisible ? "text" : "password"}
                        value={inputs.password}
                        onChange={handleChange}
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setPasswordVisible(!passwordVisible)
                                }
                                edge="end"
                                aria-label="toggle password visibility"
                              >
                                {passwordVisible ? (
                                  <VisibilityOffOutlinedIcon />
                                ) : (
                                  <VisibilityOutlinedIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                      <div
                        style={{
                          textAlign: "right",
                          marginBottom: "8px",
                          cursor: "pointer",
                          color: "var(--portal-red-colr)",
                          fontSize: "14px",
                          userSelect: "none",
                        }}
                        onClick={() => setShowPasswordRules(!showPasswordRules)}
                      >
                        Password Requirements
                      </div>
                      {showPasswordRules && (
                        <div
                          style={{
                            backgroundColor: "#f0f0f0",
                            borderRadius: 4,
                            padding: 10,
                            fontSize: 14,
                            color: "var(--portal-red-colr)",
                            marginBottom: 12,
                            lineHeight: 1.5,
                          }}
                        >
                          <p
                            style={{
                              color: passwordValidation.length
                                ? "green"
                                : "red",
                            }}
                          >
                            {passwordValidation.length ? "✓" : "✗"} At least 8
                            characters
                          </p>
                          <p
                            style={{
                              color: passwordValidation.uppercase
                                ? "green"
                                : "red",
                            }}
                          >
                            {passwordValidation.uppercase ? "✓" : "✗"} At least
                            one uppercase letter
                          </p>
                          <p
                            style={{
                              color: passwordValidation.number
                                ? "green"
                                : "red",
                            }}
                          >
                            {passwordValidation.number ? "✓" : "✗"} At least one
                            number
                          </p>
                          <p
                            style={{
                              color: passwordValidation.specialChar
                                ? "green"
                                : "red",
                            }}
                          >
                            {passwordValidation.specialChar ? "✓" : "✗"} At
                            least one special character (@, #, $, etc.)
                          </p>
                        </div>
                      )}

                      <TextField
                        fullWidth
                        required
                        label="Confirm Password"
                        name="confirm_password"
                        type={passwordVisibleConfirm ? "text" : "password"}
                        value={inputs.confirm_password}
                        onChange={handleChange}
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setPasswordVisibleConfirm(
                                    !passwordVisibleConfirm
                                  )
                                }
                                edge="end"
                                aria-label="toggle confirm password visibility"
                              >
                                {passwordVisibleConfirm ? (
                                  <VisibilityOffOutlinedIcon />
                                ) : (
                                  <VisibilityOutlinedIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={isLoading}
                        sx={{ mt: 2, mb: 2 }}
                      >
                        {isLoading ? "Submitting..." : "Reset Password"}
                      </Button>
                    </form>
                  )}
                  <div className="mt-3 text-end">
                    <Button
                      className="w-100"
                      onClick={() => {
                        if (fromState === 0) {
                          navigate(-1);
                        } else {
                          setFormState(fromState - 1);
                        }
                      }}
                    >
                      {fromState === 0
                        ? "Back to Login"
                        : "Change Verification Method"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  logoImage: {
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    marginBottom: "30px",
    objectFit: "contain",
  },
  logoTitle: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  logoSubtitle: {
    fontSize: "1.5rem",
    color: "#555",
    fontWeight: "normal",
  },
  formContainer: {
    flex: 1.4, // Increased from 1 to make right side wider
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
  formContent: {
    width: "100%",
    maxWidth: "400px",
  },
  signInTitle: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginBottom: "30px",
    color: "#333",
  },
  form: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
    boxSizing: "border-box",
  },
  visibilityToggle: {
    position: "absolute",
    right: "10px",
    top: "38px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#666",
  },
  forgotPasswordContainer: {
    textAlign: "right",
    marginBottom: "20px",
  },
  forgotPasswordLink: {
    color: "#0066cc",
    textDecoration: "none",
    fontSize: "14px",
  },
  submitButton: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#006F32",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "20px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#005999",
    },
  },
  signUpContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  signUpText: {
    color: "#555",
    fontSize: "14px",
    marginBottom: "0", // remove spacing between lines
  },

  signUpLink: {
    color: "#0071bc",
    textDecoration: "none",
    fontWeight: "bold",
    marginLeft: "5px",
  },
  scrollableFormWrapper: {
    width: "100%",
    maxWidth: "400px",
    maxHeight: "90vh",
    overflowY: "auto",
    paddingRight: "10px",

    /* Hide scrollbar for Webkit browsers (Chrome, Safari) */
    WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // Internet Explorer 10+

    // Hide scrollbar in Webkit-based browsers
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
};
